// Tiny yup → react-hook-form resolver. Lives here instead of pulling in
// `@hookform/resolvers` to avoid a new dependency. Drop-in replacement if
// we later install the official package — same call shape, same error format.

const toRhfErrors = (validationError) => {
  const errors = {};
  if (!validationError?.inner) return errors;
  for (const err of validationError.inner) {
    if (!err.path || errors[err.path]) continue; // first-error-per-path wins
    errors[err.path] = { type: err.type ?? "validation", message: err.message };
  }
  return errors;
};

export const yupResolver = (schema) => async (values) => {
  try {
    const data = await schema.validate(values, { abortEarly: false, stripUnknown: false });
    return { values: data, errors: {} };
  } catch (err) {
    return { values: {}, errors: toRhfErrors(err) };
  }
};
